import { render, staticRenderFns } from "./AcceptReject.vue?vue&type=template&id=b97b24e6&scoped=true&"
import script from "./AcceptReject.vue?vue&type=script&lang=js&"
export * from "./AcceptReject.vue?vue&type=script&lang=js&"
import style0 from "./AcceptReject.vue?vue&type=style&index=0&id=b97b24e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b97b24e6",
  null
  
)

export default component.exports